import Vue from 'vue';
import moment from 'moment';
// 空值处理
Vue.filter('ifNull', function (val) {
  // return processed value
  if (!val || (val == 'null')) {
    return ''
  } else {
    return val
  }
});


Vue.filter('nomore', function (val) {
  if(typeof(val)=='string'){
    val = Number(val)
  }
  if (!val) {
    return '0'
  } else {
    return val
  }
});
// 两位小数
Vue.filter('float', function (val) {
  if(typeof(val)=='string'){
    val = Number(val)
  }
  if (!val) {
    return '0.00'
  } else {
    return val.toFixed(2)
  }
});

// 购销类型
Vue.filter('saleType', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '采购'
    case 1:
      return '销售'
  }
});
// 合同审核状态
Vue.filter('contractApprovalState', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '起草'
    case 2:
      return '审批中'
    case 3:
      return '审核驳回'
    case 4: 
      return '审核通过'
    case 5:
      return '变更中'
    case 6:
      return '变更驳回'
  }
});
// 合同状态
Vue.filter('contractState', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '未生效'
    case 2:
      return '已生效'
    case 3:
      return '已失效'
  }
});

Vue.filter('isSaleStatus', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '已停售'
    case 1:
      return '销售中'
  }
});
// 合同是否变更中
Vue.filter('contractChangeStatus', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '无变更'
    case 2:
      return '变更中'
  }
});  

/**
 * 乐保障相关
 */

// 医保状况
Vue.filter('medicalInsurance', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '无'
    case 1:
      return '有'
  }
});  

// 证件类型
Vue.filter('idNoType', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '身份证'
    case 1:
      return '护照'
  }
});  

// 变动类型
Vue.filter('changeType', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '减员'
    case 1:
      return '增员'
  }
}); 

// 性别
Vue.filter('sex', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '女'
    case 1:
      return '男'
  }
}); 

// 职业类别
Vue.filter('careerType', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '1类'
    case 2:
      return '2类'
    case 3:
      return '3类'
    case 4:
      return '4类'
    case 5:
      return '5类'
    case 6:
      return '6类'
  }
}); 

// 保险状态
Vue.filter('insuranceStatus', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '投保中'
    case 1:
      return '已生效'
    case 2:
      return '已失效'
    case 3:
      return '已删除'
  }
}); 

// 锁定状态
Vue.filter('lockedState', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '未锁定'
    case 1:
      return '已锁定'
  }
}); 
//核销状态
Vue.filter('checkStatus', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '未核销'
    case 2:
      return '部分核销'
    case 3:
      return '全部核销'
  }
}); 


// 账单状态
Vue.filter('billStatus', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '未确认'
    case 3:
      return '已确认' 
  }
}); 
//对账的确认状态  0 待确认 1 已付款 2 已关闭 3 已确认 4 确认中
Vue.filter('fundBilldStatus', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '待确认'
    case 1:
      return '已付款'
    case 3:
      return '已确认'
    case 4:
      return '确认中' 
  }
}); 
// 支付状态
Vue.filter('paymentStatus', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '未支付'
    case 2:
      return '部分支付'
    case 3:
      return '已支付'
  }
}); 

// 审核状态
Vue.filter('approvalState', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '变更起草'
    case 2:
      return '变更审核中'
    case 3:
      return '变更通过'
    case 4: 
      return '变更驳回'
    case 5:
      return '未变更'
  }
});

// 是否变更中
Vue.filter('changeStatus', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '有变更'
    case 2:
      return '无变更'
  }
});

// 日期转换（年月日）
Vue.filter('formatDate', function (val) {
  if (val) {
    return moment(val).format('YYYY-MM-DD');
  } else {
    return ''
  }
});

// 邮件
Vue.filter('formatMail', function (val) {
  if (val === 1) {
    return "发送成功";
  } else {
    return '正在发送';
  }
});

// 日期转换（时分秒）
Vue.filter('formatTime', function (val) {
  if (val) {
    return moment(val).format('YYYY-MM-DD HH:mm:ss');
  } else {
    return ''
  }
});
//手机号
Vue.filter('hideMiddle', function (val) {
  if (val) {
    return `${val.substring(0,3)}****${val.substring(val.length-4)}`
  } else {
    return ''
  }
});
//身份证号
Vue.filter('hideIdMiddle', function (val) {
  if (val) {
    return `${val.substring(0,10)}****${val.substring(val.length-4)}`
  } else {
    return ''
  }
});
// 核销状态
Vue.filter('verificationStatus', function (val) {
  switch(val) {
    case 1:
      return '未核销'
    case 2:
      return '部分核销'
    case 3:
      return '全部核销'
  }
});

// 核销方式
Vue.filter('verificationType', function (val) {
  switch(val) {
    case 1:
      return '手动核销'
    case 2:
      return '自动核销'
  }
});

// 保障申请审核状态
Vue.filter('auditApprovalState', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '无需审核'
    case 2:
      return '待审核'
    case 5:
      return '审核通过'
  }
});
// 保障申请变更状态
Vue.filter('changeState', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '无变更'
    case 2:
      return '有变更'
  }
});
// 保障人员是否变更中
Vue.filter('updateFalg', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '无变更'
    case 2:
      return '有变更'
  }
});  

// 保障人员审核状态
Vue.filter('examineStatus', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '未变更'
    case 2:
      return '变更起草'
    case 3:
      return '变更审核中'
    case 4: 
      return '变更通过'
    case 5:
      return '变更驳回'
  }
});
//分销商---
// 分销商状态
Vue.filter('distributorStatus', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '未审核'
    case 2:
      return '已审核'
    case 3:
      return '已驳回'
  }
});
//申请类型
Vue.filter('distributorApplyStatus', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '个人'
    case 2:
      return '企业'
  }
});
//支付状态
Vue.filter('distributorPayStatus', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '未付'
    case 2:
      return '已付'
  }
});
//流程类型
Vue.filter('processDefinitionTypes', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '直线'
    case 1:
      return '分支'
  }
});
Vue.filter('authenticationSource', function (val) {
  // return processed value
  switch(val) {
    case 3:
      return '法大大'
    case 2:
      return '创蓝'
    case 1:
      return '数脉'
  }
});
Vue.filter('authenticationType', function (val) {
  // return processed value
  switch(val) {
    case 2:
      return '二要素'
    case 3:
      return '三要素'
    case 4:
      return '四要素'
  }
});
Vue.filter('settlementStatus', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '结算中'
    case 1:
      return '已结算'
    case 2:
      return '结算失败'
    case 3:
        return '已关闭'
    case 4:
       return '结算异常'
  }
});
//是否显示
Vue.filter('isShow', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '不显示'
    case 1:
      return '显示'
  }
});
//产品类型
Vue.filter('productLargeType', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '大类'
  }
});
//过滤器-数字三位加一逗号
Vue.filter('filterThree', function (value, val2) {
  // return processed value
  if (!value) return 0
  let val= val2 == 0 ? 0 : (val2 || 2);
  if (!isNaN(parseFloat(value)) && isFinite(value)) {
    let num = Number(value);
    num = num.toFixed(val) ;
    let parts = num.split('.');
    parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + ',');

    return parts.join('.');
  }
  return '0';
});
//过滤器-数字三位加一逗号,不保留两位小数
Vue.filter('filterThreeTotal', function (val) {
  if (!val) return 0
  var intPart = Number(val).toFixed(0)
  var intPartFormat = intPart.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + ',') // 将整数部分逢三一断
  return intPartFormat
});
// 财务资金管理
Vue.filter('fundStatus', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '欠款'
    case 2:
      return '正常'
    case 3:
      return '余款'
  }
});
// 财务资金管理
Vue.filter('checkoutStatus', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '未核销'
    case 2:
      return '部分核销'
    case 3:
      return '全部核销'
  }
});
// 财务资金管理
Vue.filter('monitoringStatus', function (val) {
  // return processed value
  switch(val) {
    case 0:
      return '正常'
    case 1:
      return '异常'
  }
});
// 职位是否是类型
Vue.filter('isTaskShow', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '正常'
    case 2:
      return '停用'
  }
});
//实名状态
Vue.filter('realNameStatus', function (val) {
  // return processed value
  if(val==1){
    return '未实名'
  }else{
    return '已实名'
  }

});
//录用状态
Vue.filter('enrollStatus', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '未录用'
    case 2:
      return '录用'
    case 4:
      return '已拒绝'
  }

});
//录用状态
Vue.filter('personalType', function (val) {
  // return processed value
  switch(val) {
    case 1:
      return '个人'
    case 2:
      return '团队'

  }

});